import {
  login,
  npsw,
  getUserList,
  add,
  change,
  del,
  serch,
  changeAvatar,
  getRoleList,
  changeMenu,
  getMenuList,
  addMenu,
  delMenu,
  getRoleMenu,
  changeRole,
} from "@/api/user";
import { useMessage } from "@/hooks/useMessage";
import router from "@/router/index";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    isLogin: localStorage.getItem("VUE_ADMIN_ISLOGIN") || false,
    token: localStorage.getItem(process.env.VUE_APP_TOKEN_NAME) || "",
    // 用户的菜单列表数据
    menuList:
      JSON.parse(localStorage.getItem(process.env.VUE_APP_MENU_LIST)) || [],
    menuUrls:
      JSON.parse(localStorage.getItem(process.env.VUE_APP_MENU_URLS)) || [],
    // 是否动态添加路由
    isDynamicAddedRoute: false,
    userInfo:
      JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_INFO)) || {},
    // 分页
    page: {
      // 每页条数
      pageSize: parseInt(localStorage.getItem("pageSize")) || 10,
      // 当前页码
      pageNum: 1,
      // 总条数
      total: 0,
    },
    userTableData: {
      tabeHeader: [
        {
          label: "用户名",
          prop: "username",
          width: "",
        },
        {
          label: "昵称",
          prop: "nickname",
          width: "",
        },
        {
          label: "手机",
          prop: "phone",
          width: "",
        },
        {
          label: "邮箱",
          prop: "email",
          width: "",
        },
        {
          label: "角色",
          prop: "role_name",
          width: "",
        },
        {
          label: "状态",
          prop: "is_open",
          width: "",
        },
        {
          label: "创建人",
          prop: "created_by",
          width: "",
        },
        {
          label: "创建时间",
          prop: "created_time",
          width: "",
        },

        {
          label: "备注",
          prop: "info",
          width: "",
        },
      ],
      userList: [],
    },
    roleTableData: {
      tabeHeader: [
        {
          label: "角色名称",
          prop: "ROLE_NAME",
          width: "",
        },
        {
          label: "角色值",
          prop: "ROLE_ID",
          width: "",
        },
        {
          label: "更新时间",
          prop: "UPDATED_TIME",
          width: "",
        },
        {
          label: "备注",
          prop: "ROLE_INFO",
          width: "",
        },
      ],
      roleList: [],
      page: {
        // 每页条数
        pageSize: 10,
        // 当前页码
        pageNum: 1,
        // 总条数
        total: 0,
      },
    },
    menuTableData: {
      tabeHeader: [
        {
          label: "菜单名称",
          prop: "MENU_NAME",
          width: "",
        },
        {
          label: "菜单图标",
          prop: "MENU_ICON",
          width: "",
        },
        {
          label: "类型",
          prop: "MENU_TYPE",
          width: "",
        },
        {
          label: "路由路径",
          prop: "MENU_PATH",
          width: "",
        },
        {
          label: "组件路径",
          prop: "COMPONET",
          width: "",
        },
        {
          label: "状态",
          prop: "DEL_FLAG",
          width: "",
        },
        {
          label: "排序",
          prop: "ORDER_NUM",
          width: "",
        },
      ],
      menuList: [],
    },
  },
  mutations: {
    // 设置token
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem(process.env.VUE_APP_TOKEN_NAME, token);
    },
    // 设置用户信息
    updateUserInfo(state, userInfoObj) {
      // 检查 avatar 是否存在且是 {type: 'Buffer', data: [...]}
      if (
        userInfoObj.avatar &&
        userInfoObj.avatar.type === "Buffer" &&
        Array.isArray(userInfoObj.avatar.data)
      ) {
        const uint8Array = new Uint8Array(userInfoObj.avatar.data);
        const blob = new Blob([uint8Array], { type: "image/png" }); // 你可以根据实际图像类型修改 MIME 类型
        const reader = new FileReader();
        reader.onloadend = () => {
          // reader.result 是一个 Base64 编码的字符串
          userInfoObj.avatar = reader.result;
          // 更新 state 和 localStorage
          state.userInfo = userInfoObj;
          localStorage.setItem(
            process.env.VUE_APP_USER_INFO,
            JSON.stringify(userInfoObj)
          );
        };

        reader.readAsDataURL(blob);
      } else {
        // 如果 avatar 不是 {type: 'Buffer', data: [...]}, 直接更新 state 和 localStorage
        state.userInfo = userInfoObj;
        localStorage.setItem(
          process.env.VUE_APP_USER_INFO,
          JSON.stringify(userInfoObj)
        );
      }
    },

    // 设置用户登录状态
    setLoginState(state, flag) {
      state.isLogin = flag;
      localStorage.setItem("VUE_ADMIN_ISLOGIN", flag);
    },
    // 置用户的菜单列表数据
    setMenuList(state, menuList) {
      state.menuList = menuList;
      localStorage.setItem(
        process.env.VUE_APP_MENU_LIST,
        JSON.stringify(menuList)
      );
    },
    // 置用户的菜单列表数据
    setMenuUrls(state, menuUrls) {
      state.menuUrls = menuUrls;
      localStorage.setItem(
        process.env.VUE_APP_MENU_URLS,
        JSON.stringify(menuUrls)
      );
    },
    // 处理退出登录
    logout(state) {
      state.isLogin = false;
      localStorage.removeItem("VUE_ADMIN_ISLOGIN");
      state.token = "";
      localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
      state.menuList = [];
      localStorage.removeItem(process.env.VUE_APP_MENU_LIST);
      state.userInfo = {};
      localStorage.removeItem(process.env.VUE_APP_USER_INFO);
      // 清空localStorage
      localStorage.clear();

      // console.log(router);
      router.push("/login");
    },
    // 设置是否动态添加路由
    setDynamicAddedRoute(state, flag) {
      state.isDynamicAddedRoute = flag;
    },
    // 设置用户总数据
    setUserTotal(state, res) {
      // console.log(res);
      state.page.total = res.data.total;
      state.userTableData.userList = res.data.list;
    },
    // 设置角色数据
    setRoleList(state, res) {
      state.roleTableData.page.total = res.data.total;
      const roleData = res.data.list;
      // 时间格式化
      roleData.forEach((item) => {
        if (item.UPDATED_TIME !== null)
          item.UPDATED_TIME = moment(item.UPDATED_TIME).format(
            "YYYY-MM-DD HH:mm:ss"
          );
      });
      // console.log(state.userInfo.role_id);
      if (state.userInfo.role_id !== "1001") {
        const fileterRoleData = roleData.filter((item) => {
          if (item.ROLE_ID !== "1001") return item;
        });
        state.roleTableData.roleList = fileterRoleData;
        // console.log(fileterRoleData);
      } else {
        state.roleTableData.roleList = roleData;
      }
    },
  },
  actions: {
    //异步业务
    // 登录
    loginAction({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        // console.log(data);
        login(data)
          .then((res) => {
            // // 登录成功后，需要根据后台返回的菜单数据来动态添加路由
            // dispatch("loadAsyncRoute");
            // console.log(res);
            commit("updateToken", res.data.token);
            commit("updateUserInfo", res.data.userinfo);
            commit("setMenuList", res.data.userinfo.menus);
            commit("setMenuUrls", res.data.userinfo.menu_url);
            commit("setLoginState", true);
            // 处理权限路由
            dispatch("loadAsyncRoute");
            resolve(res.message);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    // 处理权限路由，动态添加路由
    async loadAsyncRoute({ state, commit }) {
      // 保存系统中所有的权限路由
      const allRoutes = [];
      // 1、递归获取router/modules目录下的js文件  true 表示是否递归
      const routeFiles = require.context("@/router/modules", true, /\.js$/);
      // console.log(routeFiles.keys());
      routeFiles.keys().forEach((key) => {
        // console.log(routeFiles(key).default);
        const routes = require("@/router/modules" + key.split(".")[1]);
        // console.log(routes);
        allRoutes.push(...routes.default);
      });
      // console.log("所有权限路由：", allRoutes);

      // 获取当前登录用户的权限路由
      const backRoutes = state.menuUrls;
      // console.log("当前登录用户的权限路由：", backRoutes);

      // 2.比对筛选出权限路由   allRoutes中的path和backRoutes中的name进行对比
      const asyncRoutes = allRoutes.filter((item) => {
        return backRoutes.includes(item.path);
      });

      // console.log("权限路由：", asyncRoutes);
      // 3.将权限路由添加如系统中
      asyncRoutes.forEach((route) => {
        // 将这些权限路由添加到 Layout 的子路由中 子路由中name 不能重复
        if (route.path.includes("des_mw")) {
          router.addRoute("layout_mw", route);
        }
        if (route.path.includes("pvtv")) {
          router.addRoute("layout_pvtv", route);
        }
        if (route.path.includes("des_tes")) {
          router.addRoute("layout_tes", route);
        }
      });
      //如果用户权限id 为 1001 的用户，则添加所有路由
      if (state.userInfo.role_id == 1001) {
        // 则添加一个主页路由
        router.addRoute({
          path: "/",
          name: "index",
          redirect: "/platform",
        });
      }
      //如果用户权限id 为 1002 的用户，则添加/pvtv路由、/des_mw路由、/des_tes路由
      if (state.userInfo.role_id == 1002 && state.userInfo.project_type == 1) {
        // 则添加一个主页路由
        router.addRoute({
          path: "/",
          name: "index",
          redirect: "/pvtv",
        });
      }
      if (state.userInfo.role_id == 1002 && state.userInfo.project_type == 2) {
        // 则添加一个主页路由
        router.addRoute({
          path: "/",
          name: "index",
          redirect: "/des_mw",
        });
      }
      if (state.userInfo.role_id == 1002 && state.userInfo.project_type == 3) {
        // 则添加一个主页路由
        router.addRoute({
          path: "/",
          name: "index",
          redirect: "/des_tes",
        });
      }
      // 如果 用户权限id 为 1003 的用户，则添加/pvtv路由、/des_mw路由、/des_tes路由
      if (state.userInfo.role_id == 1003 && state.userInfo.project_type == 1) {
        // 则添加一个主页路由
        router.addRoute({
          path: "/",
          name: "index",
          redirect: "/pvtv",
        });
      }
      if (state.userInfo.role_id == 1003 && state.userInfo.project_type == 2) {
        // 则添加一个主页路由
        router.addRoute({
          path: "/",
          name: "index",
          redirect: "/des_mw",
        });
      }
      if (state.userInfo.role_id == 1003 && state.userInfo.project_type == 3) {
        // 则添加一个主页路由
        router.addRoute({
          path: "/",
          name: "index",
          redirect: "/des_tes",
        });
      }
      // console.log("动态路由：", router.getRoutes());
      // 标识该用户已经加载过权限路由
      commit("setDynamicAddedRoute", true);
    },

    // 处理更新用户
    async changeAction({ commit }, data) {
      // 获取用户id
      // const userId = JSON.parse(
      //   localStorage.getItem(process.env.VUE_APP_USER_INFO)
      // ).id;
      // data.updated_by = userId;
      // // 被修改用户的user_id
      // data.user_id = data.id;
      try {
        const res = await change(data);
        // console.log(res);
        if (res.code == 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        // console.log(err);
        // useMessage(err.message, "error")
        return Promise.reject(err);
      }
    },

    // 添加用户
    async addUser({ commit }, data) {
      // 获取用户id
      // const userId = JSON.parse(
      //   localStorage.getItem(process.env.VUE_APP_USER_INFO)
      // ).id;
      const created_by = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      const project_id = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).project_id;
      data.created_by = created_by;
      data.project_id = project_id;
      try {
        const res = await add(data);
        // console.log(res);
        return res;
      } catch (err) {
        // useMessage(err.message, "error")
        return Promise.reject(err);
      }
    },

    // 获取所有用户总数和列表
    async UserTotal({ commit }, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      // console.log(data);
      try {
        const res = await getUserList(data);
        commit("setUserTotal", res);
        // console.log(res);
        return res;
      } catch (err) {
        // console.log(err);
        useMessage(err.message, "error");
        // return Promise.reject(err);
      }
    },
    // 获取所有角色
    async getRoleList({ commit }, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      try {
        const res = await getRoleList(data);
        commit("setRoleList", res);
        // console.log(res);
        return res;
      } catch (err) {
        // console.log(err);
        useMessage(err.message, "error");
        // return Promise.reject(err);
      }
    },

    // 查询用户
    async serchUser({ commit }, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      try {
        // console.log(data);
        const res = await serch(data);
        commit("setUserTotal", res);
        // console.log(res);
        return res;
      } catch (err) {
        useMessage(err.message, "error");
      }
    },

    //删除用户
    async delAction({ commit }, data) {
      // console.log(data);
      data.user_id = data.id;
      try {
        const res = await del(data);
        return res;
      } catch (err) {
        // useMessage(err.message, "error")
        return Promise.reject(err);
      }
    },

    // 处理修改密码
    async nPswAction({ commit }, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      try {
        data.user_id = userId;
        // console.log(data);
        const res = await npsw(data);
        return res;
      } catch (err) {
        // console.log(err);
        // useMessage(err.message, "error")
        return Promise.reject(err);
      }
    },

    // 修改头像
    async changeAvatar({ commit }, data) {
      // 获取用户id
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      const avatarData = {
        user_id: userId,
        avatar: data,
      };
      try {
        const res = await changeAvatar(avatarData);
        if (res.code == 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取用户菜单
    async getMenuList({ commit }) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      const user_id = {
        user_id: userId,
        project_type: JSON.parse(
          localStorage.getItem(process.env.VUE_APP_USER_INFO)
        ).project_type,
      };
      try {
        const res = await getMenuList(user_id);
        if (res.code == 0) {
          commit("setMenuList", res.data.menu);
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 修改用户菜单
    async changeMenu({ commit }, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      try {
        const res = await changeMenu(data);
        if (res.code == 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 添加用户菜单
    async addMenu({ commit }, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      data.project_type = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).project_type;
      try {
        const res = await addMenu(data);
        if (res.code == 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 删除用户菜单
    async delMenu({ commit }, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      try {
        const res = await delMenu(data);
        if (res.code == 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 通过role_id和project_type获取用户权限列表
    async getRoleMenu({ commit }, data) {
      try {
        const res = await getRoleMenu(data);
        if (res.code == 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 修改用户权限信息
    async changeRole({ commit }, data) {
      const userId = JSON.parse(
        localStorage.getItem(process.env.VUE_APP_USER_INFO)
      ).id;
      data.user_id = userId;
      try {
        const res = await changeRole(data);
        if (res.code == 0) {
          return res;
        } else {
          return Promise.reject(res);
        }
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
